<template>
  <div id="login" :class="popupClasses">
    <div class="close__wrapper">
      <div class="popup__close" @click.prevent="closeModal(modal.name)">
        <img alt="image" src="@/assets/img/new/close.svg" />
      </div>
      <div class="header__popup">
        <span class="button-borderxl" @click="Register()">Регистрация</span>
        <span class="button-borderxl button-vxl">Вход</span>
      </div>
      <ValidationObserver v-slot="{ passes }">
        <form class="footer__popup" @submit.prevent="passes(Submit)">
          <div class="inputblock-reg">
            <span class="subtitle">
              Логин
            </span>
            <AppInput
              class=""
              rules="required"
              v-bind="{ bg, label: 'Логин', type: 'text' }"
              v-model="login"
            />
          </div>
          <div style="margin-bottom: 15px !important;" class="inputblock-reg">
            <span class="subtitle"> Пароль </span
            ><AppInput
              class=""
              rules="required"
              v-bind="{ bg, label: 'Пароль', type: passwordType, pass: true }"
              @updatePass="updatePass"
              v-model="password"
            />
          </div>

          <span class="forgot" @click.prevent="Restore()">
            Забыли пароль?
          </span>
          <button type="submit" class="redbtn">
            Войти
          </button>
        </form>
      </ValidationObserver>
    </div>
  </div>
</template>

<script>
import VueRecaptcha from "vue-recaptcha";
//
//
import { mapActions } from "vuex";
//

import AppInput from "@/components/ui/AppInput.vue";
export default {
  name: "LoginModal",
  props: ["modal", "bg"],
  //
  data() {
    return {
      verified: false,
      login: "",
      password: "",
      passwordType: "password"
    };
  },
  //
  methods: {
    ...mapActions("modals", ["closeModal"]),
    ...mapActions("modals", ["openModal"]),
    ...mapActions("auth", ["userRestore"]),
    ...mapActions("auth", ["userRegister"]),
    updatePass(val) {
      if (val) this.passwordType = "text";
      else this.passwordType = "password";
    },
    Register() {
      this.openModal({
        name: "register",
        success: this.userRegister
      });
      this.closeModal(this.modal.name);
    },

    Submit(data) {
      // if (this.verified === false) {
      //   alert("Подтвердите что вы не робот!");
      //   return;
      // }

      // this.verified = false;
      //

      return this.modal
        .success({ login: this.login, password: this.password })
        .then(response => {
          if (response) {
            this.closeModal(this.modal.name);
          }
          //
          return response;
        });
    },
    Restore() {
      this.openModal({
        name: "restore",
        success: this.userRestore
      });
      this.closeModal(this.modal.name);
    }
  },
  computed: {
    popupClasses() {
      if (window.screen.width < 680) {
        return ["mobpopup"];
      } else {
        return ["popup"];
      }
    }
  },

  components: { VueRecaptcha, AppInput }
};
</script>

<style>
.forgot {
  margin-top: -12px;
  font-size: 13px;
  line-height: 16px;
  cursor: pointer;
  padding-left: 21px !important;
  margin-top: 10px !important;
  color: #f80000 !important;
  margin-bottom: 36px;
}
.inputblock-reg {
  padding: 10px 20px 0px 20px;
  border-radius: 20px;
  flex: 1 0 0;
  border: 2px solid var(--main-black);
  border-bottom: 4px solid var(--main-black);
}
@media screen and (max-width: 680px) {
  .inputblock-reg {
    padding: 5px 10px 0px 10px;
    border-radius: 10px;
    flex: 1 0 0;
    border: 2px solid var(--main-black);
    border-bottom: 4px solid var(--main-black);
  }
}
.subtitle {
  color: rgba(26, 24, 20, 0.4);
}
</style>



// WEBPACK FOOTER //
// src/components/ui/Modals/Login.vue